import { baseApi } from "./baseApi"
import type { BonusTemplate, BonusAnalytics } from "../../types/bonuses"

export const promotionsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getBonusTemplates: build.query<BonusTemplate[], void>({
      query: () => ({ url: "/bonuses/templates", adminApi: "v1" }),
      providesTags: (result) =>
        result
          ? [...result.map((t) => ({ type: "Promotion" as const, id: t.id })), { type: "Promotion", id: "LIST" }]
          : [{ type: "Promotion", id: "LIST" }],
    }),
    createBonusTemplate: build.mutation<BonusTemplate, Partial<BonusTemplate>>({
      query: (body) => ({ url: "/bonuses/templates", method: "POST", body, adminApi: "v1" }),
      invalidatesTags: [{ type: "Promotion", id: "LIST" }],
    }),
    updateBonusTemplate: build.mutation<BonusTemplate, { id: string; payload: Partial<BonusTemplate> }>({
      query: ({ id, payload }) => ({ url: `/bonuses/templates/${id}`, method: "PUT", body: payload, adminApi: "v1" }),
      invalidatesTags: (_res, _err, arg) => [
        { type: "Promotion", id: arg.id },
        { type: "Promotion", id: "LIST" },
      ],
    }),
    setBonusActivation: build.mutation<BonusTemplate, { id: string; isActive: boolean }>({
      query: ({ id, isActive }) => ({
        url: `/bonuses/templates/${id}/activation`,
        method: "PATCH",
        body: { isActive },
        adminApi: "v1",
      }),
      invalidatesTags: (_res, _err, arg) => [
        { type: "Promotion", id: arg.id },
        { type: "Promotion", id: "LIST" },
      ],
    }),
    getPromotionAnalytics: build.query<BonusAnalytics, void>({
      query: () => ({ url: "/bonuses/analytics", adminApi: "v1" }),
      providesTags: [{ type: "Promotion", id: "ANALYTICS" }],
    }),
  }),
})

export const {
  useGetBonusTemplatesQuery,
  useCreateBonusTemplateMutation,
  useUpdateBonusTemplateMutation,
  useSetBonusActivationMutation,
  useGetPromotionAnalyticsQuery,
} = promotionsApi
